import LocalizedStrings from "react-localization";
import { objectTypes } from "src/consts/objectTypes";
export const lang = new LocalizedStrings({
  en: {
    showLayers: "Show layers",
    hideLayers: "Hide layers",
    skotselKod: "Maintenance code",
    reportInspection: "Report inspection",
    searchOrTypeNew: "Search or type new...",
    objectOnLocation: "Object on location",
    deleteImage: "Delete image",
    editImage: "Edit image",
    action: "Action",
    inspectionCreated: "Inspection created successfully",
    errorCreatingInspection: "Error creating inspection",
    image: "Image",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    lastCompleted: "Last emptied",
    reportBinFilled: "Report bin and bin fill-level",
    reportDeviation: "Report deviation",
    meters: "meters",
    closestBin: "Closest bin",
    closestObject: "Closest object",
    noUserGroups: "This user has not been assigned to any groups, please add this user to a group.",
    selectedGroups: "Selected Groups",
    userPosition: "Your position",
    nearbyObjects: (numberOfObjects: number) => `${numberOfObjects} nearby objects`,
    logInWithGoogle: "Log in with Google",
    inspection: "Inspection",
    deviation: "Deviation",
    item: "Item",
    items: "Items",
    savedFormResult: "Submitted form data",
    link: "Link",
    noVehicleInspectionsAdded: "No forms added",
    vehicleInspection: "Formulär",
    loginCode: "Login Code",
    planner: "Planner",
    redirecting: "Redirecting...",
    company: "Company Management",
    back: "Back",
    backToDocuments: "Back to documents",
    signingSession: "Document Signing",
    bucket: "Bucket",
    signingFileSuccessMessage: "Successfully signed file",
    taskTitle: "Task Title",
    appType: "App Type",
    file: "File",
    comment: "Comment",
    createDocument: "Add Document",
    noAddedDocuments:
      "There are currently no added documents, to add a document click the '+' icon above.",
    documents: "Documents",
    documentTitle: "Title",
    showAllObjects: "Show all objects",
    settings: "Settings",
    objectId: "Object ID",
    activateLocationData: "Activate location data",
    locationNotEnabled: "Location is not enabled",
    checked: "Checked",
    showNotCompleted: "Do not include completed",
    showCompleted: "Include completed",
    signDocument: "Sign document",
    signed: "Signed",
    loading: "Loading..",
    pageNumber: (current, total) => `${current} of ${total}`,
    reset: "Reset",
    next: "Next",
    previous: "Previous",
    signingMessage:
      "By signing below, I acknowledge that I have read, understood, and agree to the terms of this document.",
    showOnMap: "Show on map",
    clear: "Clear",
    finish: "Finish",
    drawingArea: "Drawing Area",
    translateFeatureType: (featureType: string) => {
      switch (featureType.toLowerCase()) {
        case objectTypes.Inspection.toLowerCase():
        case "egenkontroll":
          return "Inspection";
        case objectTypes.Deviation.toLowerCase():
        case "deviation":
          return "Deviation";
        case `inspection-image`:
          return "inspection image";
        case `deviation-image`:
          return "Deviation Image";
        default:
          return featureType;
      }
    },
    drawArea: "Draw Area",
    apiCredentials: "Api Credentials",
    companyName: "Company name",
    organizationNumber: "Organization number",
    zipCode: "Zip code",
    city: "City",
    country: "Country",
    manageUsers: "Manage users",
    users: "Users",
    numberOfUsers: (numberOfUsers: number) => `${numberOfUsers} users`,
    costCenter: "Cost center",
    location: "Location",
    saveGroupError: "Error saving group",
    saveUserError: "Error saving user",
    role: "Role",
    firstName: "First name",
    surname: "Surname",
    username: "Username",
    phone: "Phone",
    address: "Address",
    companyAdmin: "Company admin",
    user: "User",
    createGroupSuccess: "Group created successfully",
    saveGroupSuccess: "Group saved successfully",
    createUserSuccess: "User created successfully",
    saveUserSuccess: "User saved successfully",
    betweenDates: "Between dates",
    fileDeletedSuccessfully: "Image deleted successfully",
    fileDeletedError: "Error deleting image",
    fileCreatedError: "Error adding image",
    fileCreatedSuccessfully: "Image added successfully",
    errorGettingUser: "Error getting user",
    completionStatus: "Completion status",
    reportCreated: "Creating report.. this may take a few seconds.",
    report: "Report",
    createReport: "Create report",
    reports: "Reports",
    range: "Range",
    rangeOrDueDate: "Range or due date",
    createInspection: "Create self-inspection",
    deleted: "Deleted",
    createDeviation: "Create deviation",
    groupName: (name: string) => "Group: " + name,
    confirmInspection: "Please confirm the inspection before saving",
    attachedFiles: "Attached files",
    objectType: "Object type",
    deviationsForInspectionAddress: (address: string) =>
      "Deviations for " + address,
    kontrollmoment: "Inspection items",
    editAssignment: "Edit assignment",
    deviationFor: (name: string) => "Deviation for " + name,
    refresh: "Refresh",
    equipment: "Equipment",
    home: "Home",
    documentIntelligence: "Document Intelligence",
    resistograph: "Resistograph",
    show: "Show",
    showAssignments: "Show assignments",
    myAssignments: "My assignments",
    allInspections: "All inspections",
    noInspectionsAdded: "No inspections added",
    noDeviationsAdded: "No deviations added",
    handleDeviations: "Handle deviations",
    openInspection: (featureType: string) =>
      featureType === objectTypes.Inspection
        ? "Open inspection"
        : "Open deviation",
    by: "by",
    dueDate: "Due date",
    assignments: "Assignments",
    addAssignment: "Add Assignment",
    noAssignments: "No assignments found",
    deleteJob: "Are you sure you want to delete this job?",
    handleSelfInspection: "Handle self-inspection",
    editSelfInspection: "Edit self-inspection",
    notCompleted: "Not completed",
    completed: "Completed",
    signOut: "Sign out",
    moment: "Type",
    egenkontrollerTitle: "Self-Inspection",
    egenkontrollerDescription: "App for managing self-inspections",
    deviationTitle: "Deviation",
    deviationDescription: "App for managing deviations",
    noSelfInspections: "No self-inspections added",
    selectedAppType: {
      title: "Select Application Type",
      description: "Please select the application type you want to use.",
    },
    search: "Search",
    Egenkontroller: "Self-Inspection",
    clearFilters: "Clear filters",
    confirmSend: "Check item before saving",
    manageGroups: "Manage Groups",
    userManagement: "User Management",
    noGroupsMessage:
      "You are not a member of any groups, to add an item please make sure you are part of a group in the user management.",
    noVariationsAdded:
      'There are currently nothing reported. To add an item, use the mobile view and click "Create" in the bottom left corner.',
    property: "Property",
    value: "Value",
    linkToObject: "Link to object",
    emailSubject: `Object assigned to you.`,
    details: "Details",
    deviationReport: "Object report",
    or: "or",
    greeting: "Hi",
    youHaveBeenAssigned: "You have been assigned the case",
    ifAnyQuestionsText:
      "If you have any questions regarding this report or the app functionality, please feel free to contact",
    reportedByUser: "User",
    latitude: "Latitude",
    longitude: "Longitude",
    contact: "Contact",
    closingRemark: "Closing remark",
    editItem: "Edit item",
    editItemByObjectType: (objectType: string) =>
      objectType === objectTypes.Inspection
        ? "Edit self-inspection"
        : "Edit item",
    close: "Close",
    finishJob: "Finish Job",
    finishJobReason: "Reason for finishing",
    finishJobComment: "Comment",
    assignedTo: "Handled by",
    information: "Information",
    noFileError: "At least one file is required.",
    cancel: "Cancel",
    delete: "Delete",
    removeImageMessage: "Are you sure you want to delete this image?",
    groups: "Groups",
    create: "Create",
    selectedItem: "Selected Item",
    addImage: "Add image",
    save: "Save",
    addImages: "Add images",
    logInWithMicrosoft: "Log in with Microsoft",
    group: "Group",
    installPrompt: "Please install this app for a better user experience",
    install: "Install",
    map: "Map",
    edit: "Edit",
    displayItem: "Display item",
    filter: "Filter",
    logIn: "Log in",
    deviations: "Deviations",
    title: "Address",
    description: "Description",
    suggestion: "Suggestion",
    customer: "Customer",
    deviationType: "Type",
    statusText: "Status",
    exitCategory: "Exit category",
    improvement: "Improvement",
    urgent: "Urgent",
    vandalism: "Vandalism",
    other: "Other",
    notDetermined: "Not determined",
    maintenanceIncluded: "Maintenance Included",
    maintenanceClaim: "Maintenance Claim",
    establishmentIncluded: "Establishment Included",
    establishmentClaim: "Establishment Claim",
    created: "Created",
    contactCustomer: "Contact customer",
    sentToCustomer: "Sent to customer",
    sold: "Sold",
    finished: "Finished",
    onHold: "On hold",
    alreadyExists: "Already exists",
    ordered: "Ordered",
    workorderCreated: "Pending",
    included: "Included, sent to staff",
    createErrorMessage: "There was an error creating the item. ",
    saveFilters: "Save filters",
    claimType: "Claim type",
    endDate: "End date",
    startDate: "Start date",
    deleteAssignment: "Are you sure you want to delete this assignment?",
  },
  sv: {
    showLayers: "Visa lager",
    hideLayers: "Dölj lager",
    skotselKod: "Skötselkod",
    reportInspection: "Rapportera tillsyn",
    searchOrTypeNew: "Sök eller skriv ny...",
    objectOnLocation: "Objekt på plats",
    deleteImage: "Ta bort bild",
    editImage: "Ändra bild",
    action: "Åtgärd",
    errorCreatingInspection: "Fel vid skapande av egenkontroll",
    inspectionCreated: "Egenkontroll skapad",
    image: "Bild",
    monday: "Måndag",
    tuesday: "Tisdag",
    wednesday: "Onsdag",
    thursday: "Torsdag",
    friday: "Fredag",
    saturday: "Lördag",
    sunday: "Söndag",
    lastCompleted: "Senast tömd",
    reportBinFilled: "Rapportera tömning och skräpkorgsfyllnad",
    reportDeviation: "Rapportera avvikelse",
    meters: "meter",
    closestObject: "Närmsta objekt",
    closestBin: "Närmsta skräpkorg",
    noUserGroups: "Denna användare har inte blivit tilldelad någon grupp, vänligen tilldela en grupp under \"Hantera grupper\".",
    selectedGroups: "Valda grupper",
    nearbyObjects: (numberOfObjects: number) => `${numberOfObjects} närliggande objekt`,
    userPosition: "Din position",
    logInWithGoogle: "Logga in med Google",
    inspection: "Egenkontroll",
    deviation: "Avvikelse",
    item: "Objekt",
    items: "Objekt",
    savedFormResult: "Sparat formulärdata",
    link: "Länk till dokument",
    noVehicleInspectionsAdded: "Inga formulär tillagda",
    vehicleInspection: "Formulär",
    loginCode: "Inloggningskod",
    planner: "Planerare",
    signingSession: "Dokumentsignering",
    redirecting: "Skickar vidare...",
    company: "Företagsadministration",
    back: "Tillbaka",
    backToDocuments: "Tillbaka till dokument",
    bucket: "Kategori",
    taskTitle: "Uppgiftstitel",
    signingFileSuccessMessage: "Filen har blivit signerad",
    appType: "Apptyp",
    file: "Fil",
    comment: "Kommentar",
    createDocument: "Lägg till dokument",
    noAddedDocuments:
      "Det finns för närvarande inga tillagda dokument. För att lägga till ett dokument, tryck på '+' ovan.",
    documents: "Dokument",
    documentTitle: "Titel",
    showAllObjects: "Visa alla objekt",
    settings: "Inställningar",
    objectId: "Objekt-ID",
    activateLocationData: "Aktivera platsdata",
    locationNotEnabled:
      "Platsdata är inte aktiverad, positionen som sparas är inte tillförlitlig.",
    checked: "Klarmarkerad",
    showNotCompleted: "Exkludera avslutade",
    showCompleted: "Inkludera klarmarkerade",
    signDocument: "Signera dokument",
    signed: "Signerad",
    loading: "Laddar..",
    pageNumber: (current, total) => `${current} av ${total}`,
    next: "Nästa",
    previous: "Föregående",
    reset: "Återställ",
    signingMessage:
      "Genom denna signatur intygar jag att jag läst och förstått ovan dokument.",
    showOnMap: "Visa på karta",
    clear: "Rensa",
    finish: "Slutför",
    drawingArea: "Ritar område..",
    translateFeatureType: (featureType: string) => {
      switch (featureType.toLowerCase()) {
        case objectTypes.Inspection.toLowerCase():
        case "egenkontroll":
          return "Egenkontroll";
        case objectTypes.Deviation.toLowerCase():
        case "deviation":
          return "Avvikelse";
        case `inspection-image`:
          return "Bild på egenkontroll";
        case `deviation-image`:
          return "Bild på avvikelse";
        default:
          return featureType;
      }
    },
    drawArea: "Rita område",
    apiCredentials: "Api-lösningar",
    companyName: "Företagsnamn",
    organizationNumber: "Organisationsnummer",
    zipCode: "Postnr",
    city: "Stad",
    country: "Land",

    manageUsers: "Hantera användare",
    users: "Användare",
    numberOfUsers: (numberOfUsers: number) => `${numberOfUsers} användare`,
    costCenter: "Kostnadsställe",
    location: "Plats",
    betweenDates: "Mellan datum",
    saveGroupError: "Fel vid sparande av grupp",
    saveUserError: "Fel vid sparande av användare",
    role: "Roll",
    firstName: "Förnamn",
    surname: "Efternamn",
    username: "Användarnamn",
    phone: "Telefon",
    address: "Adress/Område",
    companyAdmin: "Företagsadmin",
    user: "Användare",
    createGroupSuccess: "Grupp skapad",
    saveGroupSuccess: "Grupp sparad",
    createUserSuccess: "Användare skapad",
    saveUserSuccess: "Användare sparad",
    fileDeletedSuccessfully: "Bild borttagen",
    fileDeletedError: "Fel vid borttagande av bild",
    fileCreatedError: "Fel vid tillagande av bild",
    fileCreatedSuccessfully: "Bild tillagd",
    errorGettingUser: "Fel vid hämtning av användare",
    completionStatus: "Färdigställningsstatus",
    reportCreated: "Skapar protokoll.. detta kan dröja några sekunder.",
    report: "Protokoll",
    createReport: "Skapa protokoll",
    reports: "Rapporter",
    range: "Datumspann",
    rangeOrDueDate: "Intervall eller utförandedatum",
    createInspection: "Skapa egenkontroll",
    deleted: "Borttagen",
    createDeviation: "Skapa avvikelse",
    groupName: (name: string) => "Avdelning: " + name,
    confirmInspection: "Vänligen kontrollera egenkontrollen innan den sparas",
    attachedFiles: "Bilagor",
    objectType: "Objekt/Moment",
    type: "Typ",
    deviationsForInspectionAddress: (address: string) =>
      "Avvikelser för " + address,
    editAssignment: "Redigera uppgift",
    kontrollmoment: "Kontrollmoment",
    deviationFor: (name: string) => "Avvikelse för " + name,
    refresh: "Uppdatera",
    resistograph: "Resistograf",
    equipment: "Utrustning",
    home: "Startsida",
    documentIntelligence: "Fakturaanalys",
    show: "Visa",
    showAssignments: "Visa uppgifter",
    myAssignments: "Mina uppgifter",
    allInspections: "Alla kontroller",
    noInspectionsAdded: "Inga egenkontroller tillagda",
    noDeviationsAdded: "Inga avvikelser tillagda",
    handleDeviations: "Hantera avvikelser",
    openInspection: (featureType: string) =>
      featureType === objectTypes.Inspection
        ? "Visa egenkontroll"
        : "Visa avvikelse",
    by: "av",
    dueDate: "Utförandedatum",
    assignments: "Tilldelade uppgifter",
    addAssignment: "Tilldela uppgift",
    noAssignments: "Inga uppgifter hittades",
    deleteJob: "Är du säker på att du vill ta bort denna egenkontroll?",
    handleSelfInspection: "Hantera egenkontroll",
    editSelfInspection: "Redigera egenkontroll",
    notCompleted: "Ej godkänd",
    completed: "Godkänd",
    signOut: "Logga ut",
    suggestion: "Förslag",
    moment: "Fokusområde",
    egenkontrollerTitle: "Egenkontroller",
    egenkontrollerDescription: "App för att hantera egenkontroller",
    deviationTitle: "Avvikelser",
    deviationDescription: "App för att hantera avvikelser",
    noSelfInspections: "Inga egenkontroller tillagda",
    selectedAppType: {
      title: "Välj app",
      description: "Välj den app du vill använda.",
    },
    search: "Sök",
    Egenkontroller: "Egenkontroller",
    clearFilters: "Rensa filter",
    confirmSend: "Kontrollera ärendet innan det sparas.",
    manageGroups: "Hantera grupper",
    userManagement: "Användarhantering",
    noGroupsMessage:
      "Du är inte medlem i någon grupp. Använd https://portal.glservices.se för att hantera grupper eller kontakta någon med tillgång.",
    noVariationsAdded:
      "Det finns för närvarande inga avvikelser tillagda. För att lägga till en avvikelse, använd mobilversionen och tryck på Skapa nere i vänstra hörnet.",
    property: "Kolumn",
    value: "Värde",
    linkToObject: "Länk till avvikelse",
    emailSubject: `Du har blivit tilldelad en avvikelse`,
    details: "Detaljer",
    deviationReport: "Avvikelserapport",
    or: "eller",
    greeting: "Hej",
    youHaveBeenAssigned: "Du har blivit tilldelad avvikelsen",
    ifAnyQuestionsText:
      "Om du har några frågor gällande denna rapport eller inspektions-appen, vänligen kontakta ",
    reportedByUser: "Skapad av",
    latitude: "Latitud",
    longitude: "Longitud",
    contact: "Kontakt",
    closingRemark: "Avslutskommentar",
    editItem: "Redigera",
    editItemByObjectType: (objectType: string) =>
      objectType === objectTypes.Inspection
        ? "Redigera egenkontroll"
        : "Redigera avvikelse",
    close: "Stäng",
    finishJob: "Avsluta jobb",
    finishJobReason: "Anledning till avslut",
    finishJobComment: "Avslutskommentar",
    assignedTo: "Utförs av",
    information: "Information",
    noFileError: "Vänligen lägg till minst en bild.",
    delete: "Ta bort",
    cancel: "Avbryt",
    removeImageMessage: "Är du säker på att du vill ta bort bilden?",
    groups: "Grupper",
    create: "Skapa",
    selectedItem: "Vald kontroll",
    addImage: "Lägg till bild",
    save: "Spara",
    addImages: "Lägg till bilder",
    logInWithMicrosoft: "Logga in med Microsoft",
    group: "Avdelning",
    installPrompt: "Vänligen installera denna app för att använda den. ",
    install: "Installera",
    map: "Karta",
    edit: "Ändra",
    displayItem: "Vald kontroll",
    filter: "Filter",
    logIn: "Logga in",
    deviations: "Avvikelser",
    title: "Adress",
    description: "Kommentar",
    customer: "Kund",
    deviationType: "Avvikelsetyp",
    statusText: "Status",
    exitCategory: "Anledning till färdigställning",
    improvement: "Förbättringsförslag",
    urgent: "Akut",
    vandalism: "Vandalism",
    other: "Övrigt",
    notDetermined: "Ej bestämd",
    maintenanceIncluded: "Skötsel ingår",
    maintenanceClaim: "Skötsel ÄTA",
    establishmentIncluded: "Anläggning ingår",
    establishmentClaim: "Anläggning ÄTA",
    created: "Skapad",
    contactCustomer: "Kontakta kund",
    sentToCustomer: "Skickat till kund",
    sold: "Insåld",
    finished: "Avslutad",
    onHold: "On Hold",
    alreadyExists: "Existerar redan",
    ordered: "Beställd",
    workorderCreated: "Väntar",
    included: "Inkluderad, skickad till personal",
    createErrorMessage: "Fel påträffades vid skapande av avvikelsen",
    saveFilters: "Spara filter",
    claimType: "ÄTA-typ",
    endDate: "Slutdatum",
    startDate: "Startdatum",
    deleteAssignment: "Är du säker på att du vill ta bort denna uppgift?",
  },
});
